/* Enforce one "Birthday Ritual" total, even if apps create separate lines with unique properties */
(() => {
  const BIRTHDAY_PRODUCT_ID = 7371854020721; // exact product id
  const CART_ENDPOINT   = '/cart.js';
  const ADD_ENDPOINT    = '/cart/add.js';
  const CHANGE_ENDPOINT = '/cart/change.js';

  async function getCart() {
    const res = await fetch(CART_ENDPOINT, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Cart fetch failed');
    return res.json();
  }

  // Returns all line indexes (1-based) for Birthday Ritual, in order of appearance
  async function getBirthdayLineIndexes() {
    const cart = await getCart();
    const idxs = [];
    cart.items.forEach((i, ix) => {
      if (Number(i.product_id) === Number(BIRTHDAY_PRODUCT_ID)) idxs.push(ix + 1); // 1-based for /cart/change.js
    });
    return idxs;
  }

  // Keep only the first Birthday line and make sure quantity is 1
  async function normalizeBirthdayLines() {
    const idxs = await getBirthdayLineIndexes();
    if (idxs.length === 0) return false;

    // Build a set of change calls: first line -> quantity 1, all others -> 0
    const updates = [];
    for (let j = 0; j < idxs.length; j++) {
      const line = idxs[j];
      updates.push(fetch(CHANGE_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ line, quantity: j === 0 ? 1 : 0 })
      }));
    }
    if (updates.length) await Promise.all(updates);

    return idxs.length > 1;
  }

  // On checkout click, normalize first, then continue
  function guardCheckout() {
    async function onCheckoutAttempt(e) {
      try {
        const changed = await normalizeBirthdayLines();
        if (changed) {
          e.preventDefault();
          alert('Only one Birthday Ritual is allowed. We adjusted your cart.');
          document.dispatchEvent(new CustomEvent('rebuy:cart.refresh'));
          // Reload to reflect the correction in any cart UI
          window.location.reload();
        }
      } catch (_) {}
    }

    document.addEventListener('click', (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      const isCheckout =
        t.matches('button[name="checkout"], [href="/checkout"], form[action="/checkout"] [type="submit"], .cart__checkout, .rebuy-cart__checkout-button');
      if (isCheckout) onCheckoutAttempt(e);
    }, true);
  }

  // Rebuy hooks and DOM changes trigger normalization
  function hookCartUI() {
    const handler = async () => {
      const changed = await normalizeBirthdayLines();
      if (changed) document.dispatchEvent(new CustomEvent('rebuy:cart.refresh'));
    };
    document.addEventListener('rebuy:cart.ready', handler);
    document.addEventListener('rebuy:cart.change', handler);

    // Mutation observer as safety net for other carts/drawers
    const mo = new MutationObserver(() => handler());
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  // Wrap fetch so any add-to-cart (including BOXI) gets normalized right after
  function interceptAddsAndNormalize() {
    const origFetch = window.fetch;
    window.fetch = async function(input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const method = (init && (init.method || 'GET')) || 'GET';

      const isAdd = url.includes(ADD_ENDPOINT) && method.toUpperCase() === 'POST';
      const resp = await origFetch.apply(this, arguments);

      if (isAdd) {
        try {
          const changed = await normalizeBirthdayLines();
          if (changed) document.dispatchEvent(new CustomEvent('rebuy:cart.refresh'));
        } catch (_) {}
      }
      return resp;
    };
  }

  async function boot() {
    interceptAddsAndNormalize();
    hookCartUI();
    guardCheckout();

    // First-load normalization in case multiple lines are already present
    try {
      const changed = await normalizeBirthdayLines();
      if (changed) {
        document.dispatchEvent(new CustomEvent('rebuy:cart.refresh'));
        window.addEventListener('load', () => setTimeout(() => window.location.reload(), 120));
      }
    } catch (_) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
